module.exports = __webpack_public_path__ + "food.svg?e5221fc07412f56a3abf74720a24e673";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/food.svg
// module id = 33
// module chunks = 0